import { Link } from 'react-router-dom';

export interface PlayHeaderActionsProps {
  /**
   * Whether the in-engine clock is currently running. Used to show
   * the Pause button only when pausing has a meaningful effect (the
   * live run is ticking forward). Always-on Restart and Quit don't
   * gate on this — restarting from the start overlay or after the
   * results card is exactly the muscle-memory shortcut a rhythm
   * player wants.
   */
  isPlaying: boolean;
  onPause: () => void;
  onRestart: () => void;
  /**
   * data-testid prefix so e2e specs can target the restart / pause
   * controls in a mode-aware way (`play-restart-button`,
   * `circles-play-restart-button`, etc.).
   */
  testIdPrefix: string;
}

/**
 * In-game header controls shared by Pulse / Circles / Piano play pages.
 * Restart button, an optional Pause button while the clock is
 * running, and Quit. Volume is owned by the global top nav speaker
 * popover — there is no per-mode mid-run volume control here.
 */
export function PlayHeaderActions({
  isPlaying,
  onPause,
  onRestart,
  testIdPrefix,
}: PlayHeaderActionsProps) {
  return (
    <div className="play-header-actions">
      <button
        type="button"
        className="btn btn-ghost"
        onClick={onRestart}
        data-testid={`${testIdPrefix}-restart-button`}
        title="Restart this run"
      >
        Restart
      </button>
      {isPlaying && (
        <button
          type="button"
          className="btn btn-ghost"
          onClick={onPause}
          data-testid={`${testIdPrefix}-pause-button`}
        >
          Pause <span className="kbd-hint">(P)</span>
        </button>
      )}
      <Link to="/" className="btn btn-ghost">
        Quit
      </Link>
    </div>
  );
}
